<template>
  <Layout
    :errors="errors"
    :title="trans(`models.${resourceType}.content.edit.action`)"
    :toasts="toasts"
    :resource="model"
  >
    <div class="row">
      <div :class="'col-8 pe-2'">
        <div v-if="model.data" class="card rounded-corner">
          <div class="card-body">
            <div class="model-title-bar">
              <h5 class="card-title text-primary fw-bold text-uppercase">
                {{ trans(`models.${resourceType}.content.edit.action`) }}
              </h5>
            </div>
            <p class="card-text">
              {{ trans(`models.${resourceType}.content.edit.description`) }}
            </p>
            <resource-form
              :action-title="'Änderungen an mehreren ' + trans(`models.${resourceType}.name.plural`) + ' durchführen'"
              :enabled-fields="{}"
              :errors="errors"
              :resource="model"
              @updateData="refreshPendingChanges"
            ></resource-form>
          </div>
        </div>
      </div>
      <div class="col-4 ps-2 pe-4">
        <card title="Durchzuführende Änderungen">
          <div v-for="(value, field) in pendingChanges" :key="field">
            <div v-if="pendingChanges[field] && !model.meta.belongsTo[field]" class="row">
              <div class="col-3">
                {{
                  trans(
                    `models.${resourceType}.` +
                      (pendingChanges[field + '_id'] !== null ? 'attributes' : 'relations') +
                      `.${field}`
                  )
                }}
              </div>
              <div class="col-1 px-0">??? =></div>
              <div class="col-8 ps-1">{{ pendingChanges[field + '_id'] ?? pendingChanges[field] }}</div>
            </div>
          </div>
        </card>
      </div>
    </div>
  </Layout>
</template>

<script>
import Card from '@/structures/default/components/Base/Card';
import Layout from '@/structures/moviary/Pages/Layout';
import ResourceForm from '@/structures/default/components/ResourceForm';
import { ref } from 'vue';
import useResource from '@/structures/default/composables/useResource';

export default {
  components: {
    Card,
    Layout,
    ResourceForm,
  },
  props: {
    aspectMenuItems: { type: Object, default: () => {} },
    model: { type: Object, default: () => {} },
    toasts: { type: Object, default: () => {} },
    errors: { type: Object, default: () => {} },
  },
  setup(props) {
    const { resourceType } = useResource(props, props.model);
    const pendingChanges = ref({});

    const getAvailableFields = () => {
      let fields = {};
      let sections = props.model.form.sections;
      for (let section in sections) {
        if (Object.keys(sections[section]).length > 0) {
          for (let column in sections[section]) {
            fields[column] = false;
            fields[column + '_id'] = false;
          }
        }
      }

      return fields;
    };

    const fields = ref(getAvailableFields());

    const refreshPendingChanges = (data) => {
      pendingChanges.value = data;
    };

    return {
      fields,
      resourceType,
      pendingChanges,
      refreshPendingChanges,
    };
  },
};
</script>
